import { c as _c } from "react/compiler-runtime";
import { EntityName } from 'record-it-time-common/EntityName';
import { EntityRepositoryByEntityName } from '../../classes/entities/AppEntityManager';
import { useEntityManager } from './useEntityManager';
export function useEntityRepository(entityName) {
  const $ = _c(3);
  const {
    entityManager
  } = useEntityManager();
  let t0;
  if ($[0] !== entityManager.entityRepositoryContainer || $[1] !== entityName) {
    t0 = entityManager.entityRepositoryContainer.getByEntityName(entityName);
    $[0] = entityManager.entityRepositoryContainer;
    $[1] = entityName;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
}